module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_62.3278c14a.jpg";